import { DeepPartial } from 'utility-types';

import { getCookie } from '../../tag/TagUtils';
import { ConceptName } from '../types/ConceptName';
import { DataRoleModel } from '../types/DataRoleModel';


export type DataRoleFieldSynonymWebClient = Exclude<ConceptName, 'is_primary'> & {
  readonly isPrimary: boolean;
};

export type DataRoleUpdateModel = DeepPartial<DataRoleModel>;

export const updateDataroleApi = (luid: string, updateModel: DataRoleUpdateModel): Promise<Response> => {
  if (!luid) { return Promise.reject(); }
  const TagHeaders = new Headers({ 'X-XSRF-TOKEN': getCookie('XSRF-TOKEN'), 'Content-Type': 'application/json' });

  const targetUrl = `${window.location.origin}/services/semantic-model/data-roles/${luid}`;
  return fetch(targetUrl, {
    body: JSON.stringify(updateModel),
    headers: TagHeaders,
    method: 'PATCH',
    cache: 'no-cache',
    credentials: 'include',
  });
};
